exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uploading-image[data-v-557a542c] {\n  display: -webkit-box;\n  display: flex;\n}\n.col-form-label[data-v-557a542c] {\n  white-space: nowrap;\n}\n", ""]);

// exports
